module.exports = __webpack_public_path__ + "assets/img/yeswear.2eca07c5.png";